import React, { useContext } from 'react';

import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { SPACE_OVERVIEW } from '@confluence/named-routes/entry-points/routes.ts';
import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context.ts';
import { SPAViewContext } from '@confluence/spa-view-context/entry-points/SPAViewContext.ts';
import { getCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';
import { fg } from '@confluence/feature-gating';

const CUSTOM_HOMEPAGE_QUERY_PARAMS = { mode: 'global' };

type SiteHomepageRedirectProps = {
	children?: React.ReactNode;
};

export const SiteHomepageRedirect = ({
	children,
}: SiteHomepageRedirectProps): React.JSX.Element | null => {
	const { homepageUri, loading, error } = useContext(SPAViewContext);

	if (loading) {
		return null;
	}

	const spaceMatchRoute = SPACE_OVERVIEW.match(`${CONTEXT_PATH}${homepageUri}`);

	if (!error && spaceMatchRoute) {
		// In the standalone Company Hub app we don't want to redirect to Company Hub
		// since it will no longer be part of Confluence, so we'll default to Confluence Home for now
		const isCompanyHub = homepageUri.includes(getCompanyHubSpaceKey());
		// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
		if (fg('company-hub-set-as-landing-page') || !isCompanyHub) {
			return (
				<Redirection
					name={SPACE_OVERVIEW.name}
					params={{
						...spaceMatchRoute.params,
						query: CUSTOM_HOMEPAGE_QUERY_PARAMS,
					}}
				/>
			);
		}
	}

	return <>{children}</>;
};
